import { render } from "./EasyFacebookWidgetDemo.vue?vue&type=template&id=70552446"
import script from "./EasyFacebookWidgetDemo.vue?vue&type=script&lang=js"
export * from "./EasyFacebookWidgetDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__